import styled from "@emotion/styled";
import { css } from "@emotion/core";
import { NectarTheme } from "@nectarTypes";
import { Button } from "nectar-ui";

export const DocumentItemContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;

    ${theme.breakpoints.sm} {
      display: grid;
      grid-template-columns: 130px 1fr 228px;
      grid-template-rows: 1fr auto;
      grid-template-areas:
        ". . ."
        "divider divider divider";
    }
  `}
`;

export const AttachmentContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    width: 90%;
    display: flex;
    flex-direction: column;
    margin-left: 30px;
    font-size: 16px;
    padding-top: ${theme.spacings.xxs};
  `}
`;

export const TitleContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    column-gap: 12px;
    align-items: center;
    margin-top: 17px;

    ${theme.breakpoints.sm} {
      margin-top: 0;
    }
  `}
`;

export const AttachmentLinkButton = styled(Button)<NectarTheme>`
  ${({ theme }) => css`
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
    margin-top: ${theme.spacings.xs};
    width: fit-content;
    font-weight: 300;
  `}
`;

export const DownloadAllButton = styled(Button)<NectarTheme>`
  ${({ theme }) => css`
    margin-top: 24px;

    ${theme.breakpoints.sm} {
      margin-top: 0;
    }
  `}
`;
